'use client';

import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
import { useSchedulerStoreContext } from '@mui/x-scheduler-internals/use-scheduler-store-context';
export function useEventTimelinePremiumStoreContext() {
  const context = useSchedulerStoreContext();
  if (context.instanceName !== 'EventTimelinePremiumStore') {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Scheduler: useEventTimelinePremiumStoreContext must be used within an <EventTimelinePremium /> component' : _formatErrorMessage(264));
  }
  return context;
}